import { take, takeUntil } from 'rxjs/operators';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { LookupService } from 'src/app/services/lookup-data.service';
import { PetitionerService } from 'src/app/services/petitioner.service';
import { AttorneyProfileService } from 'src/app/services/attorney-profile.service';
import * as errorUtils from 'src/app/modules/utility/global-utils';
import { USER_PERMISSIONS } from 'src/app/data/constants/permissions';
import { combineLatest, Subject } from 'rxjs';
import { ReferenceLibraryService } from 'src/app/services/referenceLibrary.service';
import { ReferenceLibrary } from 'src/app/data/models/referenceLibrary.model';
@Component({
  selector: 'app-petition-task',
  templateUrl: './petition-task.component.html',
  styleUrls: ['./petition-task.component.scss']
})
export class PetitionTaskComponent implements OnInit, OnDestroy {
  @Input() parentFormGroup: FormGroup;
  @Input() subTaskDetails: any;
  petitionTaskForm: FormGroup;
  serviceCenters: any[] = [];
  reviewUsersList: any[] = [];
  attorneys: any[] = [];
  attorneyUsers: any[] = [];
  users: any[] = [];
  selectedSignatory: any;
  selectedDesignation: any;
  selectedPreparer: any;
  selectedPetetionPreprarer: any;
  // questionAndResponseDTO: FormArray;
  questionList: any[];
  userType: string;
  primaryCompanyId: number;
  employeeDetails: any;
  isAttorneySelect: boolean;
  isOutsideImagility = true;
  oldServiceCenterName: string;
  oldAttorneyCompanyName: string;
  oldPreparerAttorneyName: string;
  petitionUpdates: boolean[] = [false, false];
  visaType: string;
  foreignCompanyList: any[] = [];
  companyRelationList: ReferenceLibrary[] = [];
  fieldExtrAbltyCodeList: ReferenceLibrary[] = [];
  extraBLDOCEVDNCATGList: ReferenceLibrary[] = [];
  majorInternationAwardList: any[] = [];
  applicableOptionItem = [{
    code: String,
    name: String,
    description: String
  }]
  public checksForOVisa: [
    {
      code: String,
      name: String,
      description: String
    }
  ];
  private ngUnsubscribe: Subject<void> = new Subject();
  fields: {
    showAdditionalAnswerForQuestions: boolean;
    showDividerBeforeForeignCompany: boolean;
    showForeignCompany: boolean;
    showRelationshipOfUSCompanyWithForeignCompany: boolean;
    showTreatyCountry: boolean;
  } = {
      showAdditionalAnswerForQuestions: false,
      showDividerBeforeForeignCompany: false,
      showForeignCompany: false,
      showRelationshipOfUSCompanyWithForeignCompany: false,
      showTreatyCountry: false
    };
  additionalInfoTextAnswerRequiredVisaTypeArray = ['L1A', 'L1B', 'E1', 'E2', 'E2C', 'O1A', 'O1B', 'TN1', 'TN2','H1-B'];
  isExtension: boolean = false;
  duplicatePetitionerList = {
    petitionType: [],
    company:[],
    beneficiaryList: [],
    selectedPetitionType:[],
    visaType:'',
    selectedBeneficiaryId:0
   }
  isDuplicatedData:boolean = false;
  lawFirmUsersList: any[] = [];
  selectedLawFirmUsers: any[] = [];
  selectedLawFirmUsersTextArr: any[] = [];

  constructor(
    private fb: FormBuilder, private lookupService: LookupService,
    private petitionerService: PetitionerService,
    private attorneyProfileService: AttorneyProfileService,
    private referenceLibraryService: ReferenceLibraryService) {
    this.petitionTaskForm = this.fb.group({
      authorizedSignatoryId: [null, Validators.required],
      processingType: [null],
      beneficiaryType:['named'],
      serviceCenterId: [null],
      attorneyId: [null],
      immSpecialistId: [null, Validators.required],
      preparerAttorneyId: [null],
      immigrantTypeCode: [null],
      isAttorneySame: [0],
      isCaseTransferred: [0],
      selectedDesignation: [null],
      questionAndResponseDTO: this.fb.array([]),
      lawFirmUsers: [null]
    });
  }

  ngOnInit(): void {
    this.visaType = this.parentFormGroup.get('visaType').value;
    this.postNgOnInit();
    switch (this.visaType) {
      case 'L1A':
      case 'L1B':
        this.petitionTaskForm.patchValue({
          immigrantTypeCode: 'VISA'
        });
        this.petitionTaskForm.addControl('companyRelationCode', new FormControl(null, Validators.required));
        this.petitionTaskForm.addControl('foreignCompanyId', new FormControl(null, Validators.required));
        this.fields = {
          showAdditionalAnswerForQuestions: true,
          showDividerBeforeForeignCompany: true,
          showForeignCompany: true,
          showRelationshipOfUSCompanyWithForeignCompany: true,
          showTreatyCountry: false
        };
        break;
      case 'E1':
      case 'E2':
      case 'E2C':
        this.petitionTaskForm.patchValue({
          immigrantTypeCode: 'VISA'
        });
        this.petitionTaskForm.addControl('companyRelationCode', new FormControl(null, Validators.required));
        this.petitionTaskForm.addControl('foreignCompanyId', new FormControl(null, Validators.required));
        this.petitionTaskForm.addControl('treatyCountry', new FormControl(null));
        this.fields = {
          showAdditionalAnswerForQuestions: true,
          showDividerBeforeForeignCompany: true,
          showForeignCompany: true,
          showRelationshipOfUSCompanyWithForeignCompany: true,
          showTreatyCountry: true
        };
        break;
      case 'O1A':
      case 'O1B':
        this.petitionTaskForm.addControl('fieldExtrAbltyCode', new FormControl(null, Validators.required));
        this.petitionTaskForm.addControl('extrAblDocEvdCatgCode', new FormControl('', Validators.required));
        this.petitionTaskForm.addControl('applicableOptionIds', this.fb.array([]));
        this.petitionTaskForm.addControl('applicableOptionCodes', this.fb.array([]));

        this.petitionTaskForm.addControl('ownershipInterestInPetitionOrg', new FormControl(false));
        this.petitionTaskForm.addControl('explanationownershipInterestInPetitionOrg', new FormControl({value:null, disabled: true}));
        // this.petitionTaskForm.setValidators(this.applicableOptionIdsRequired());
        this.fields = {
          showAdditionalAnswerForQuestions: true,
          showDividerBeforeForeignCompany: false,
          showForeignCompany: false,
          showRelationshipOfUSCompanyWithForeignCompany: false,
          showTreatyCountry: false
        };
        this.getExtraOrdinaryDetailsOVisa();
        break;
      case 'TN1':
      case 'TN2':
      case 'H1-B':
        this.fields = {
          showAdditionalAnswerForQuestions: true,
          showDividerBeforeForeignCompany: false,
          showForeignCompany: false,
          showRelationshipOfUSCompanyWithForeignCompany: false,
          showTreatyCountry: false
        };
        break;
      case 'H1-B':
        this.fields = {
          showAdditionalAnswerForQuestions: true,
          showDividerBeforeForeignCompany: false,
          showForeignCompany: false,
          showRelationshipOfUSCompanyWithForeignCompany: false,
          showTreatyCountry: false
        };
        break;

    }

    if (this.petitionTaskForm) {
      for (const [key, value] of Object.entries(this.petitionTaskForm.controls)) {
        this.parentFormGroup.addControl(key, value);
      }
      this.parentFormGroup.updateValueAndValidity();
    }
    this.userType = sessionStorage.getItem('userTypeRole');
    this.primaryCompanyId = parseInt(sessionStorage.getItem('companyId'));
    let isOnlySignatory = true; // to load the signatory users
    combineLatest([      
      this.lookupService.getReviewersUser(this.parentFormGroup.get('companyId').value, USER_PERMISSIONS.PETITION_REVIEWER, isOnlySignatory),
      this.lookupService.getActiveAttorneyCompanyList(sessionStorage.getItem('companyId')),
      this.lookupService.getUsersOfCompany(this.parentFormGroup.get('companyId').value),
      this.referenceLibraryService.getReferenceData('USFORGNCOMPREL')
    ])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.reviewUsersList = data[0] || [];
        this.attorneys = Object.assign([],[{attorneyId:null, attorneyName:"Select attorney"},...data[1]]);
        this.users = data[2];
        this.companyRelationList = data[3];
        this.petitionTaskForm.patchValue({
          authorizedSignatoryId: this.parentFormGroup.value.authorizedSignatoryId,
          selectedDesignation: '',
          immSpecialistId: this.subTaskDetails && this.subTaskDetails.immSpecialistId,
          processingType: this.subTaskDetails && this.subTaskDetails.processingType,
          beneficiaryType: this.subTaskDetails && this.subTaskDetails.beneficiaryType ? this.subTaskDetails.beneficiaryType:null,
          
        });
        if(['O1A','O1B'].includes(this.visaType)){
          this.petitionTaskForm.patchValue({
            ownershipInterestInPetitionOrg: this.subTaskDetails?.ownershipInterestInPetitionOrg,
            explanationownershipInterestInPetitionOrg: this.subTaskDetails?.explanationownershipInterestInPetitionOrg
          });
          if(this.subTaskDetails?.ownershipInterestInPetitionOrg){
            this.petitionTaskForm.get('explanationownershipInterestInPetitionOrg').enable();
          }
        }
        this.onPetitionerPreparerSelected();
        if(this.parentFormGroup.value.authorizedSignatoryId){
          this.userSelected();
        }
        if(this.subTaskDetails && this.subTaskDetails.processingType){
          this.onChangeProcessingType();
        }
        if (this.userType !== 'Attorney') {
          this.petitionTaskForm.patchValue({
            attorneyId: this.subTaskDetails && this.subTaskDetails.attorneyId,
            preparerAttorneyId: 0
          });
          this.attorneySelected();
          this.isAttorneySelect = true;
          switch (this.visaType) {
            case 'L1A':
            case 'L1B':
              this.petitionerService.getPetitionerClientList(this.parentFormGroup.get('companyId').value, 'notInCountry')
                .pipe(take(1))
                .subscribe((response: any[]) => {
                  this.foreignCompanyList = response;
                  if(this.foreignCompanyList.length && this.subTaskDetails && this.subTaskDetails.foreignCompanyId){
                    this.petitionTaskForm.patchValue({
                      foreignCompanyId: this.subTaskDetails.foreignCompanyId,
                      companyRelationCode: this.subTaskDetails?.foreignCompanyRelationCode
                    });
                    this.onForeignCompanyChange();
                  }
                  this.getQuestionListForCreateTask();
                });
              break;
            case 'E1':
            case 'E2':
            case 'E2C':
              this.petitionerService.getForeignCompanyListForEVisa(this.visaType, this.parentFormGroup.get('companyId').value)
                .pipe(take(1))
                .subscribe((response: any[]) => {
                  this.foreignCompanyList = response;
                  if(this.foreignCompanyList.length && this.subTaskDetails && this.subTaskDetails.foreignCompanyId){
                    this.petitionTaskForm.patchValue({
                      foreignCompanyId: this.subTaskDetails.foreignCompanyId,
                      companyRelationCode: this.subTaskDetails?.foreignCompanyRelationCode
                    });
                    this.onForeignCompanyChange();
                  }
                  this.getQuestionListForCreateTask();
                });
              break;
            default:
              this.getQuestionListForCreateTask();
          }
          
        } else {
          this.isAttorneySelect = false;
          if (this.parentFormGroup.get('companyId').value) {
            this.getForeignCompanyListForAttorney();
          }
          this.attorneyProfileService.getEmployeeDetails(
            this.primaryCompanyId, parseInt(sessionStorage.getItem('employeeId')))
            .pipe(take(1))
            .subscribe((response: any) => {
              this.employeeDetails = response;
              sessionStorage.setItem("setPreparerAttorneyId", this.employeeDetails['id']);
              this.petitionTaskForm.patchValue({
                attorneyId: response.companyId
              });
              this.attorneySelected();
              this.getQuestionListForCreateTask();
            });
        }
      });
  }

  postNgOnInit() {
    // Get Specific Task Details
    if(this.subTaskDetails){
      //console.log('subTaskDetails:',this.subTaskDetails);
      if(this.subTaskDetails.taskTypeId){
        sessionStorage.setItem(
          "taskTypeId",
          JSON.parse(JSON.stringify(this.subTaskDetails.taskTypeId))
        );
      }

      if(this.subTaskDetails.taskTypeDetails.petitionType === 'EXTNSN' || this.subTaskDetails.taskTypeDetails.petitionType === 'AMEND') {
        this.duplicatePetitionerList.selectedPetitionType = this.subTaskDetails.taskTypeDetails.petitionType;
         this.isExtension = true;
         sessionStorage.setItem('isDuplicated', 'true');
     } else {
       this.isExtension = false;
         sessionStorage.removeItem('isDuplicated');
     }

     if(this.subTaskDetails.taskTypeDetails.visaType) {
      this.duplicatePetitionerList.visaType = this.subTaskDetails.taskTypeDetails.visaType;
     }

    }

  }
  // applicableOptionIdsRequired(): ValidatorFn {
  //   return (group: FormGroup): { [s: string]: boolean } => {
  //     // console.log(this.petitionTaskForm.value);
  //     console.log(group.value.extrAblDocEvdCatgCode);
  //     if (this.petitionTaskForm.get('extrAblDocEvdCatgCode').value && this.petitionTaskForm.get('extrAblDocEvdCatgCode').value === 'OTHERDOCEVDN' && group.value.applicableOptionIds.length < 3) {
  //       return { applicableOptionIdsIsRequired: true };
  //     }
  //     return null;
  //   }
  // }


  onForeignCompanyChange() {
    if (['E1', 'E2', 'E2C'].includes(this.visaType)) {
      this.petitionTaskForm.patchValue({
        treatyCountry: this.foreignCompanyList.find(x => x.id === this.petitionTaskForm.get('foreignCompanyId').value)?.countryName
      });
    }
  }

  get applicableOptionGroups() {
    return (this.petitionTaskForm.get('applicableOptionIds') as FormArray).controls;
  }

  clickRadioBtn(extrAblDocEvdCatgCode) {

    (this.petitionTaskForm.get('applicableOptionIds') as FormArray).patchValue((this.petitionTaskForm.get('applicableOptionIds') as FormArray).value.map((x, i) => {
      if (x) {
        this.updateCheckedOptions(false, this.majorInternationAwardList[i].code);
      }
      return false;
    }));
  }

  updateCheckedOptions(checked, code: string) {
    const applicableOptionIds = ((this.petitionTaskForm.get('applicableOptionCodes') as FormArray).value as string[]);
    if (checked) {
      if (!applicableOptionIds.includes(code)) {
        (this.petitionTaskForm.get('applicableOptionCodes') as FormArray).push(new FormControl(code));
      }
    } else {
      if (applicableOptionIds.includes(code)) {
        (this.petitionTaskForm.get('applicableOptionCodes') as FormArray).removeAt(applicableOptionIds.indexOf(code));
      }
    }
  }

  getExtraOrdinaryDetailsOVisa() {
    let fieldExtrAbltyCode;
    let payload;
    if (this.visaType === 'O1A') {
      fieldExtrAbltyCode = 'O1AFLDEXTRABL';
      payload = ['OTHERDOCEVDN'];
    } else {
      fieldExtrAbltyCode = 'O1BFLDEXTRABL';
      payload = ['OTHERDOCEVDN', 'O1BSPECDOCEVDN'];
    }
    combineLatest([
      this.referenceLibraryService.getReferenceData('EXTRABLDOCEVDNCATG'),
      this.referenceLibraryService.postReferenceData(payload),
      this.referenceLibraryService.getReferenceData(fieldExtrAbltyCode)
    ]).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.extraBLDOCEVDNCATGList = data[0];
        this.majorInternationAwardList = data[1];
        const applicableOptionIdsFormArray = this.petitionTaskForm.get('applicableOptionIds') as FormArray;
        applicableOptionIdsFormArray.clear();
        this.majorInternationAwardList.forEach((el) => {
          let flag = false;
          if(this.subTaskDetails?.extrAblDocEvdList?.length){
            const savedElement = this.subTaskDetails.extrAblDocEvdList?.find((x)=> x.code === el.code);
            flag = savedElement ? true : false;
          }
          applicableOptionIdsFormArray.push(new FormControl(flag));
        });
        // console.log(applicableOptionIdsFormArray.value);
        this.fieldExtrAbltyCodeList = data[2];
        this.petitionTaskForm.patchValue({
          fieldExtrAbltyCode: this.subTaskDetails?.fieldExtrAblty?.code ? this.subTaskDetails.fieldExtrAblty.code : null,
          extrAblDocEvdCatgCode: this.subTaskDetails?.extrAblDocEvdCatg?.code ? this.subTaskDetails?.extrAblDocEvdCatg?.code : this.extraBLDOCEVDNCATGList[0].code
        });
        if(this.subTaskDetails?.extrAblDocEvdList?.length){
          this.subTaskDetails.extrAblDocEvdList?.forEach((x)=> {
            this.updateCheckedOptions(true, x.code);
          });
        }
      });
  }

  getForeignCompanyListForAttorney() {
    switch (this.visaType) {
      case 'L1A':
      case 'L1B':
        this.petitionerService.getPetitionerClientList(this.parentFormGroup.get('companyId').value, 'notInCountry')
          .pipe(take(1))
          .subscribe((response: any[]) => {
            this.foreignCompanyList = response;
            if(this.foreignCompanyList.length && this.subTaskDetails && this.subTaskDetails.foreignCompanyId){
              this.petitionTaskForm.patchValue({
                foreignCompanyId: this.subTaskDetails.foreignCompanyId,
                companyRelationCode: this.subTaskDetails?.foreignCompanyRelationCode
              });
              this.onForeignCompanyChange();
            }
          });
        break;
      case 'E1':
      case 'E2':
      case 'E2C':
        this.petitionerService.getForeignCompanyListForEVisa(this.visaType, this.parentFormGroup.get('companyId').value)
          .pipe(take(1))
          .subscribe((response: any[]) => {
            this.foreignCompanyList = response;
            if(this.foreignCompanyList.length && this.subTaskDetails && this.subTaskDetails.foreignCompanyId){
              this.petitionTaskForm.patchValue({
                foreignCompanyId: this.subTaskDetails.foreignCompanyId,
                companyRelationCode: this.subTaskDetails?.foreignCompanyRelationCode
              });
              this.onForeignCompanyChange();
            }
          });
        break;
    }
  }

  getFormQuestionsArray() {
    return (this.petitionTaskForm.get('questionAndResponseDTO') as FormArray).controls;
  }

  getQuestionListForCreateTask() {
    this.isOutsideImagility = this.parentFormGroup.get('isOutsideImagility').value;
    let quesCategory;
    switch (this.visaType) {
      case 'H1-B':
        quesCategory = 'TASKQUES';
        break;
      case 'TN1':
      case 'TN2':
        quesCategory = 'TNTASKQUESTYPE';
        break;
      case 'L1A':
        quesCategory = 'L1AVISAQUECTGTYP';
      case 'L1B':
          quesCategory = 'L1BVISAQUECTGTYP';
          break;
      case 'E1':
      case 'E2':
        quesCategory = 'E2VISAQUECTGTYP';
        break;
      default:
        quesCategory = 'VISAQUECTGTYP';
        break;
    }
    this.petitionerService.getTaskQuestioneryOnCategory(quesCategory)
      .pipe(take(1))
      .subscribe((response: any[]) => {
        this.questionList = response ? response.map((item: any, index: number) => {
          return {
            ...item,
            answer: !!(item.answer && item.answer === 1)
          };
        }) : [];
        const questionAndResponseDTO = this.parentFormGroup.get('questionAndResponseDTO') as FormArray;
        questionAndResponseDTO.clear();
        this.questionList.forEach((x, index) => {
          questionAndResponseDTO.push(this.createQuestionList(x, index));
        });
      });
  }

  createQuestionList(item, i): FormGroup {
    const savedItem = this.subTaskDetails && this.subTaskDetails.questionAndResponseDTO.find((x)=> x.id === item.id);
    return new FormGroup({
      answer: new FormControl(savedItem ? Boolean(savedItem.answer) : item.answer),
      id: new FormControl(item.response && item.response.id ? item.response.id : null),
      questionId: new FormControl(item.id),
      isBoolean: new FormControl(true),
      additionalInfo: new FormControl(savedItem ? savedItem.additionalInfo : null),
      sequenceNumber: new FormControl(item.sequenceNumber),
      question: new FormControl(item.question),
      isAdditionalInfoReq: new FormControl(item?.isAdditionalInfoReq),
      conditionalVisibilityAtTask: new FormControl(item?.conditionalVisibilityAtTask),
      hasExplanation: new FormControl(item?.hasExplanation)
    }, (item?.isAdditionalInfoReq && i !== 1) ? this.additionalInfoRequired.bind(this) : null); //Added condition to make the explanation boxes non-mandatory (i=1 is having explanation box)
  }

  additionalInfoRequired(group: FormGroup): { [s: string]: boolean } {
    if (!this.isOutsideImagility && this.additionalInfoTextAnswerRequiredVisaTypeArray.includes(this.visaType) &&
      group.value.answer && !group.value.additionalInfo) {
      return { additionalInfoIsRequired: true };
    }
    return null;
  }

  onQuestionToggle(questionIndex: number, answer: boolean): void {
    if (!answer) {
      const questionGroup = (this.parentFormGroup.get('questionAndResponseDTO') as FormArray).controls[questionIndex] as FormGroup;
      questionGroup.patchValue({
        additionalInfo: null
      });
    }
  }

  onChangeProcessingType() {
    this.serviceCenters = [];
    this.getServiceCenter();
  }

  getServiceCenter() {
    const processingType = this.petitionTaskForm.get('processingType').value;
    const petitionType = this.parentFormGroup.get('petitionType').value;
    this.lookupService.getServiceCenters(
      (processingType === 'regular') ? 'false' : 'true', this.visaType, petitionType)
      .subscribe((data: Array<any>) => {
        this.serviceCenters = data;
        if(this.subTaskDetails && this.subTaskDetails.serviceCenterId){
          this.petitionTaskForm.patchValue({serviceCenterId: this.subTaskDetails.serviceCenterId});
        }
      });
  }

  userSelected() {
    const id = this.petitionTaskForm.get('authorizedSignatoryId').value;
    this.selectedSignatory = this.reviewUsersList.find(ele => ele.id === id);
    this.petitionTaskForm.patchValue({
      selectedDesignation: this.selectedSignatory?.designation ?? null,
    });
    this.parentFormGroup.patchValue({
      authorizedSignatoryId: id,
    });
    this.selectedDesignation = this.selectedSignatory?.designation ?? null;
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  attorneySelected() {
    const attorneyId = this.petitionTaskForm.get('attorneyId').value;
    if (attorneyId && attorneyId !== '') {
      combineLatest([
        this.lookupService.getReviewersUser(attorneyId,USER_PERMISSIONS.PETITION_REVIEWER),
        this.lookupService.getUsersOfCompany(attorneyId),
      ])
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          this.attorneyUsers = data ? data[0] : [];
          this.lawFirmUsersList = data ? data[1] : [];
          if(this.subTaskDetails && this.subTaskDetails.preparerAttorneyId){
            this.petitionTaskForm.patchValue({preparerAttorneyId: this.subTaskDetails.preparerAttorneyId});
            this.userPreparerSelected();
          }
          if(this.subTaskDetails && this.subTaskDetails.lawFirmUsers){
            this.petitionTaskForm.patchValue({lawFirmUsers: this.subTaskDetails.lawFirmUsers});
            this.usersLawFrimSelected();
          }
        });
    }
    else {
      this.attorneyUsers = [];
    }
  }

  userPreparerSelected() {
    const id = this.petitionTaskForm.get('preparerAttorneyId').value;
    this.selectedPreparer = this.attorneyUsers.find(ele => ele.id === id);
    sessionStorage.setItem("setPreparerAttorneyId", this.selectedPreparer['id']);
  }

  usersLawFrimSelected(){
    const ids = this.petitionTaskForm.get('lawFirmUsers').value;
    this.selectedLawFirmUsers = ids.length ? this.lawFirmUsersList.filter(ele => ids.includes(ele.id)) : []; 
    this.selectedLawFirmUsersTextArr = [];
    this.selectedLawFirmUsers.forEach((el)=>{
      this.selectedLawFirmUsersTextArr.push(`${el.firstName} ${el.lastName}`);
    });
  }

  onPetitionerPreparerSelected() {
    const id = this.petitionTaskForm.get('immSpecialistId').value;
    this.selectedPetetionPreprarer = this.users.find(ele => ele.id === id);
  }

  isDuplicatedtoggle(e:any, checked:boolean) {
    console.log(e,checked);
    if(e === 'duplicated') {
      this.isDuplicatedData = checked;
    }
  }
  onExtraQuestionToggle(){
    if(this.petitionTaskForm.get('ownershipInterestInPetitionOrg').value){
      this.petitionTaskForm.get('explanationownershipInterestInPetitionOrg').enable();
    }else{
      this.petitionTaskForm.get('explanationownershipInterestInPetitionOrg').disable();
    }
  }

  ngOnDestroy() {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    if (this.petitionTaskForm) {
      for (const [key, value] of Object.entries(this.petitionTaskForm.controls)) {
        this.parentFormGroup.removeControl(key);
      }
    }
    sessionStorage.setItem("setPreparerAttorneyId", "undefined");
  }

}
